module.exports = __webpack_public_path__ + "img/OmbParkG.7bc0b1a9.png";